import { createSelector } from 'reselect';
// Import state types.
import {
	AppState,
} from '@app/redux/states';
// Import app models.
import {
	ProcessTarget,
} from '@app/models/app';
// Import enumerations.
import {
	OverlayTarget
} from '@app/enumerations';

// Fetches the process target.
const getProcessTarget = (state: AppState, overlayTarget: OverlayTarget): ProcessTarget | undefined => {
	if (state.processTargets !== undefined) {
		return state.processTargets[overlayTarget];
	}
	return undefined;
}

// Fetches the message of a process target.
const getProcessTargetMessage = (state: AppState, overlayTarget: OverlayTarget, messageId: string): string | undefined => {
	if (state.processTargets !== undefined
		&& state.processTargets[overlayTarget] !== undefined) {
		return state.processTargets[overlayTarget].messages[messageId];
	}
	return undefined;
}


// Get Process Target Messages Selector.
const makeGetProcessTargetMessagesSelector = () => createSelector(
	[getProcessTarget],
	(processTarget: ProcessTarget | undefined): string[] => {
		let messages: string[] = [];
		if (processTarget !== undefined) {
			messages = Object.keys(processTarget.messages).map((messageId: string) => {
				return processTarget.messages[messageId];
			});
		}
		return messages;
	}
);


// Are Process Target Messages Empty Selector.
const makeAreProcessTargetMessagesEmptySelector = () => createSelector(
	[getProcessTarget],
	(processTarget: ProcessTarget | undefined): boolean => {
		if (processTarget !== undefined) {
			return Object.keys(processTarget.messages).map((messageId: string) => {
				return processTarget.messages[messageId];
			}).every((message: string) => {
				return message === undefined;
			});
		}
		return true;
	}
);


// Get Process Target Message Selector.
const makeGetProcessTargetMessageSelector = () => createSelector(
	[getProcessTargetMessage],
	(message: string | undefined): string | undefined => {
		return message;
	}
);

// export selectors.
export {
	makeGetProcessTargetMessagesSelector,
	makeGetProcessTargetMessageSelector,
	makeAreProcessTargetMessagesEmptySelector,
};